export default class PrimaryContactModel {
  value: string;
  label: string;

  constructor(data: any) {
    this.value = data.value || undefined;
    this.label = data.label || undefined;
  }
}
